<template>
    <span @click="click">
        <router-link
            :class="`convention-sections-menu-item ${item.class ? item.class : ''} ${item.type}`"
            :to="getUrl()"
            :ref="item.key"
        >
            <typo :class="`link ${open ? 'open' : ''} level-${item.level}`" name="body-12-normal">
                {{ title }}
            </typo>
        </router-link>
        <br />
        <typo v-if="item.legend" class="legend" name="body-10-normal">
            <i>{{ item.legend }}</i>
        </typo>
    </span>
</template>

<script>
import scrollManager from "../../managers/scrollManager";

export default {
    components: {},
    props: ["item", "open"],
    methods: {
        getUrl() {
            const { conventionId, variantNumber } = this.$route.params;
            return `/espace-client/conventions-collectives/${conventionId}/${variantNumber}/obligations/${this.item.key}`;
        },
        stripTags(rawText) {
            if (!rawText) return "";
            // Remove tags except comments
            return rawText.replace(/(<([^>!]+)>)/gi, "");
        },
        click() {
            if (this.item.class === "empty") {
                return;
            }
            scrollManager.scrollToId(this.item.key);
            this.$emit("active", this.item.key);
        },
    },
    computed: {
        title() {
            return this.stripTags(this.item.title);
        },
    },
};
</script>

<style lang="sass">
.convention-sections-menu-item
    .link
        color: $color-secondary
</style>

<style scoped lang="sass">
.legend
    position: relative
    top: -5px

@media print
    .link.body-12-normal
        font-size: 9pt
</style>
